<script setup>

import NavButton from '../components/NavButton.vue'
import ResultsChart from '../components/ResultsChart.vue'
import {computed} from "vue";
import {round10} from '@/math.js'
import { store } from '@/store'

const emit = defineEmits(['reset']);
const props = defineProps({
  title: String,
})

const canAfford = computed(() => {
  return (store.formData.savingsTotal.weekly >= store.formData.standardTotal.value)
})
const resetForm = () => {
  store.formState.page = 'home';
  emit('reset');
}
</script>

<template>
  <div class="page__my-results">
    <h2>{{ props.title }}</h2>
    <!-- <div class="callout-box">
      <p v-if="canAfford">
        Your results are in and fortunately it looks like your current retirement savings will be sufficient to fund your desired income in retirement.
      </p>
      <p v-if="!canAfford">
        Your results are in and unfortunately it doesn't look like your current retirement savings will be sufficient to fund your desired income in retirement.
      </p>
    </div> -->
    <div class="row">
      <div class="col-md-7">
        <ResultsChart/>
      </div>
      <div class="col-md-5">
        <div class="results-what-next callout-box outline">
          <h3 class="rwn__title">What next?</h3>
          <p>Your Retirement Living Standard requires an income of £{{
              round10(store.formData.standardTotal.value)
            }} per week.</p>
          <div v-if="canAfford">
            <p>Currently, it looks like you are on track but you should regularly check back to ensure this remains the
              case.</p>
          </div>
          <div v-if="!canAfford">
            <p>Your current retirement savings is estimated to provide you with a retirement income at age
              {{ store.formData.user.sra }} of £{{ round10(store.formData.savingsTotal.weekly) }} per week.</p>
            <p>It would appear your retirement savings are not sufficient to meet your desired retirement income at age
              {{ store.formData.user.sra }}.</p>
            <p><strong>What could you do to address this potential shortfall?</strong></p>
            <ul>
              <li>Consider paying a little more into your Personal Account. Click <a
                  href="https://dc.prudentialstaffps.co.uk/interactive-tools/contribution-calculator" target="_blank">here</a>
                to go to the Contribution Calculator.
              </li>
              <li>Consider retiring a little later. Go to ‘<a href="https://dc.prudentialstaffps.co.uk/my-account"
                                                              target="_blank">My account</a>’ to model what your
                benefits could be at a different Selected Retirement Age.
              </li>
            </ul>
          </div>
          <p class="rwn__warning"
             v-if="store.formData.user.sraBeforeSpa && store.formData.savings.state.totalWeekly > 0">We have excluded
            your State Pension of £{{ round10(store.formData.savings.state.totalWeekly) }} per week as this will
            not be payable until you reach your State Pension Age.</p>
        </div>
      </div>
    </div>
    <div class="nav-bar">
      <NavButton dir="<" v-on:click="store.formState.page = 'retirementSavings'">Add my retirement savings</NavButton>
      <NavButton dir="<<" v-on:click="resetForm"></NavButton>
    </div>
  </div>
</template>
